export const TabProvider = [
    {
        key: '1',
        name: 'All'
    }
]